// @flow
import { getCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  // POST_SUBSCRIBE: `${environment.apiUrl}/auth/subscribe`,
  GET_USER_WISH_LIST: `${environment.apiUrl}/wishlist/:userId/:nameSlug`,
});

// export const subscribeApi = postCreator(fetch, endpoints.POST_SUBSCRIBE);
export const getUserWishListApi = getCreator(fetch, endpoints.GET_USER_WISH_LIST);



// WEBPACK FOOTER //
// ./src/modules/home/api.js